import api, { ResponsePayloadWithData } from '.';
import { NodeHierarchy } from '../pages/material/api/materialApi';

export const getSignedUrls = async (signedUrlsToFetch: string[]) => {
  const { data } = await api.post<ResponsePayloadWithData<Record<string, string>>>(
    '/s3-files/sign-urls',
    { ids: signedUrlsToFetch },
    { params: { extendedTimeValidity: true } },
  );

  return data;
};

export type Word = {
  id: string;
  moduleId: string;
  nodeId: string;
  hierarchy: NodeHierarchy[];
  untranslated: string;
  translated: string;
  image?: string;
  sentence?: string;
  extra?: string;
  synonyms?: string;
  filters?: {
    wordType?: string;
  };
  maleVoice?: string;
  femaleVoice?: string;
};

export type Wordlist = {
  id: string;
  name: string;
  moduleId: string;
  nodeId: string;
  canSwitchLanguage: boolean;
  type: 'single' | 'compiled';
  sourceLanguage: {
    name: string;
    abbreviation: string;
  };
  targetLanguage: {
    name: string;
    abbreviation: string;
  };
  words: Word[];
  createdAt: string;
  updatedAt: string;
};

export const getWordlist = async (moduleId: string, wordlistId: string) => {
  const { data } = await api.get<Wordlist>(`/studio/modules/${moduleId}/word-lists/${wordlistId}`);

  return data;
};

export const getFavoriteWordsForModule = async (moduleId: string) => {
  const { data } = await api.get<ResponsePayloadWithData<string[]>>(`/studio/user/modules/${moduleId}/words`);

  return data;
};

export const putFavoriteWord = async (moduleId: string, wordId: string) => {
  await api.put(`/studio/user/modules/${moduleId}/words/${wordId}`);
};

export const deleteFavoriteWord = async (moduleId: string, wordId: string) => {
  await api.delete(`/studio/user/modules/${moduleId}/words/${wordId}`);
};

export const deleteFavoriteWords = async (moduleId: string, words: string[]) => {
  await api.post(`/studio/user/modules/${moduleId}/words/delete`, { words });
};
